import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageDelivery1"><Path d="M13.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V10.5M18.25 20.5L16.1287 18.3765C14.9571 17.2038 14.9571 15.3023 16.1287 14.1296C17.3003 12.9568 19.1997 12.9568 20.3713 14.1296C21.5429 15.3023 21.5429 17.2038 20.3713 18.3765L18.25 20.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageDelivery1;
